import React from 'react'
import { useAgentChatSession } from '@/features/medconnect-agent/model/useAgentChatSession'
import { AgentChatLayout } from '@/features/medconnect-agent'

/**
 * Admin Agent Chat Page
 * Uses the shared hook and layout with admin agent type.
 */
export function MedConnectAdminAgentPage() {
    const session = useAgentChatSession({ basePath: '/medconnect-admin-agent', agentType: 'admin' })

    return <AgentChatLayout {...session} agentType="admin" titleSuffix=" (Admin)" />
}
